/** THE WRITE GATE: a reason writes are paused, or null. Every write the
 *  framework sends (create, modify, delete) asks it first, as the versioning
 *  client does. Set by the island store (client caching stage 2): a page
 *  drawn from what the browser kept, whose open has not answered (offline),
 *  sends no write until it is confirmed (VC-core, 2026-10-19). */

let gate: () => string | null = () => null;

export function setWriteGate(fn: () => string | null): void {
  gate = fn;
}

export function writePausedReason(): string | null {
  try { return gate(); } catch { return null; }
}

/** Thrown in place of a write while writes are paused. */
export class WritesPaused extends Error {
  readonly code = "writes_paused";
  constructor(reason: string) {
    super(reason);
    this.name = "WritesPaused";
  }
}

export function assertWritesAllowed(): void {
  const reason = writePausedReason();
  if (reason) throw new WritesPaused(reason);
}
